import React from 'react';
import { useApp } from '../context/AppContext';
import { Calendar } from 'lucide-react';
import VencimientosWidget from './VencimientosWidget';

export default function CalendarPage() {
  const { policies, clients } = useApp();

  return (
    <div className="page fade-in">
      <div className="page-header">
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <div style={{ width: 40, height: 40, borderRadius: 12, background: 'rgba(80,140,220,0.15)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Calendar size={20} color="var(--blue)" />
          </div>
          <div>
            <h1 className="page-title">Calendario</h1>
            <p className="page-subtitle">Cuentas críticas y vencimientos de pólizas</p>
          </div>
        </div>
      </div>

      <VencimientosWidget policies={policies} clients={clients} />
    </div>
  );
}
